import { render, staticRenderFns } from "./placeholder-collection-list.vue?vue&type=template&id=78f77cb0&scoped=true"
import script from "./placeholder-collection-list.vue?vue&type=script&lang=js"
export * from "./placeholder-collection-list.vue?vue&type=script&lang=js"
import style0 from "./placeholder-collection-list.vue?vue&type=style&index=0&id=78f77cb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f77cb0",
  null
  
)

export default component.exports